import { useCallback, useState, useEffect, useMemo } from 'react';
import { denormalize } from 'normalizr';
import { useSelector } from 'react-redux';

export function useQuery({ queryId, query = (_queryId) => {}, schema }) {
  const queryState = useSelector((state) => state.queries[queryId]);
  const entities = useSelector((state) => state.entities);

  const refresh = useCallback(() => query(queryId), [query, queryId]);

  const [hasLoaded, setHasLoaded] = useState(false);
  const [result, setResult] = useState(null);
  const [resultQueryId, setResultQueryId] = useState(queryId);

  if (resultQueryId !== queryId) {
    setResultQueryId(queryId);
    setResult(null);
    setHasLoaded(false);
  }

  useEffect(() => {
    if (queryState?.isLoading === false) {
      setResult(
        schema
          ? denormalize(queryState?.result ?? [], schema, entities)
          : queryState.result
      );
      setHasLoaded(true);
    }
  }, [queryId, queryState?.isLoading, entities, schema, queryState?.result]);

  const val = useMemo(
    () => ({
      refresh,
      result: resultQueryId === queryId ? result : null,
      isLoading: queryState?.isLoading ?? false,
      hasLoaded: resultQueryId === queryId ? hasLoaded : false,
      error: queryState?.error ?? null,
    }),
    [
      refresh,
      result,
      resultQueryId,
      queryId,
      queryState?.isLoading,
      hasLoaded,
      queryState?.error,
    ]
  );

  return val;
}
